
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wekan-0-adding-new-snap-settings-to-code.json") })
        }
      }, "path---wekan-0-adding-new-snap-settings-to-code");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---wekan-0-adding-new-snap-settings-to-code!./.cache/json/wekan-0-adding-new-snap-settings-to-code.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---wekan-0-adding-new-snap-settings-to-code!./.cache/json/wekan-0-adding-new-snap-settings-to-code.json
// module chunks = 154